var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 806,
    height: 694,
    viewBox: "0 0 806 694",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.391 142.248C88.5792 181.822 69.6122 229.317 64.688 279.228L26.7793 273.698C32.7055 216.793 54.6094 162.727 89.9605 117.743L119.391 142.248Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.062 585.425C397.83 608.449 339.137 615.819 281.865 606.67C224.594 597.521 171.118 572.232 127.708 533.77L153.122 505.106C191.088 538.716 237.844 560.811 287.916 568.805C337.987 576.799 389.299 570.359 435.842 550.241L451.062 585.425Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.847 305.692V0.888299C249.904 0.788366 173.143 32.1994 116.202 88.3124L142.262 116.471L153.263 128.32L172.5 149.031L310.005 297.012L318.079 305.753L319.149 306.903L322.802 310.819L324.054 312.172L326.073 314.19L329.121 317.48L323.953 318.994L240.102 508.841C219.114 499.571 199.698 487.087 182.552 471.84L315.98 321.316L303.465 324.969L120.037 378.542L92.8675 386.475L77.3447 390.997L40.5059 401.756C57.4518 452.666 87.5317 498.204 127.708 533.77L153.102 505.106C191.067 538.716 237.824 560.812 287.895 568.805C337.966 576.799 389.279 570.36 435.822 550.241L429.464 535.405L418.24 509.466C397.744 518.372 376.01 524.103 353.787 526.463L329.847 305.692ZM329.847 305.692L305.988 84.9213C267.217 89.0433 230.232 103.371 198.802 126.443L329.847 305.692Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.745 152.624C102.843 189.876 85.1178 234.573 80.6352 281.509L64.6885 279.228C69.6201 229.331 88.5868 181.851 119.392 142.289L131.745 152.624Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316 321.316L320.501 316.229L323.549 312.797L324.155 312.111L329.847 305.692H318.18H315.031H247.712H107.805",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5449 305.692H63.3964H2.83936",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.688 533.77L93.6748 572.143",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.102 505.106L163.82 493.015L182.573 471.84",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M596.298 305.692C596.314 357.663 581.13 408.504 552.617 451.956C524.104 495.407 483.506 529.571 435.822 550.241L429.383 535.405C469.047 518.221 503.584 491.058 529.632 456.561C555.68 422.064 572.35 381.41 578.019 338.557C583.688 295.703 578.162 252.113 561.981 212.029C545.799 171.946 519.512 136.737 485.681 109.83L495.773 97.174C527.156 122.111 552.498 153.818 569.905 189.926C587.312 226.033 596.334 265.608 596.298 305.692Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M485.68 109.83L468.078 132.034C453.261 120.195 436.978 110.317 419.633 102.644L431.058 76.7661C450.603 85.4081 468.961 96.5201 485.68 109.83Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M495.753 97.1739L549.871 29.1482H610.428",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M468.079 131.934L329.847 305.692",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310.469 126.403L305.988 84.9213C267.217 89.0433 230.232 103.371 198.802 126.443L223.428 160.133C248.956 141.405 278.987 129.767 310.469 126.403Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M349.932 491.562L353.788 526.463C376.01 524.103 397.744 518.372 418.24 509.466L404.11 476.766C386.933 484.494 368.653 489.486 349.932 491.562Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M353.788 526.463C315.036 530.62 275.873 524.544 240.203 508.84L324.054 318.994L316.081 321.316L182.653 471.84C159.145 451.017 140.329 425.437 127.453 396.793C114.577 368.149 107.935 337.096 107.966 305.692C107.966 298.91 108.269 292.188 108.895 285.506C112.631 243.763 128.159 203.943 153.667 170.69C159.539 163.024 165.904 155.748 172.722 148.91C180.864 140.723 189.638 133.191 198.963 126.383L330.009 305.631L353.788 526.463Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M436.831 63.4639L430.998 76.6653",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M419.572 102.543L329.847 305.692",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M301.385 42.4304L302.94 56.8228L305.988 84.9212",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M329.847 305.692L87.6191 198.708",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.077 329.551L80.9781 332.6C80.0212 323.662 79.5428 314.68 79.5449 305.692H107.805C107.8 313.662 108.224 321.627 109.077 329.551Z",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9783 332.599L66.5859 334.154",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M329.847 305.692L116.081 461.969",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M222.863 547.92L228.697 534.719L240.122 508.841",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M323.973 318.994L324.902 316.875L325.85 314.735L326.093 314.19L329.847 305.692",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.368 604.682L356.755 554.561L353.707 526.463",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M486.125 519.458L477.566 507.771L460.893 484.941",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M329.847 305.692L572.075 412.676",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M329.847 305.692L593.109 277.23",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M543.613 149.414L531.926 157.973",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M509.096 174.647L329.847 305.692",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M329.347 139.246V491.802C251.166 446.187 210.868 381.867 190.111 328.877C179.698 302.296 174.204 278.569 171.313 261.488C169.867 252.949 169.073 246.072 168.64 241.332C168.423 238.962 168.297 237.126 168.225 235.884C168.189 235.263 168.166 234.791 168.153 234.474C168.15 234.398 168.147 234.331 168.145 234.273C205.023 209.63 239.274 191.483 267.422 176.61L268.307 176.142C295.442 161.805 316.886 150.474 329.347 139.246Z",
    fill: "url(#paint0_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M329.847 138.11C354.635 161.203 418.079 184.537 492.059 234.012C492.059 234.012 487.437 401.251 329.847 492.672V138.11Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M329.847 152.341C299.932 173.112 248.075 192.894 179.524 238.756C179.524 238.756 183.824 393.722 329.847 478.421C475.87 393.722 480.15 238.857 480.15 238.857C411.619 192.894 360.005 173.112 329.847 152.341Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M330.347 477.551V153.39C342.763 161.833 358.697 170.15 377.828 180.135C381.857 182.238 386.028 184.415 390.338 186.683C415.502 199.924 445.442 216.282 479.64 239.118C479.638 239.167 479.636 239.222 479.633 239.283C479.621 239.576 479.6 240.013 479.567 240.588C479.5 241.738 479.383 243.437 479.183 245.631C478.782 250.02 478.046 256.388 476.706 264.295C474.028 280.11 468.938 302.081 459.292 326.694C440.066 375.751 402.745 435.297 330.347 477.551Z",
    fill: "url(#paint1_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M386.791 308.579H274.761C273.552 308.592 272.352 308.367 271.23 307.917C270.109 307.466 269.086 306.799 268.222 305.954C267.358 305.109 266.669 304.101 266.194 302.99C265.719 301.878 265.468 300.684 265.455 299.475V247.82C265.455 212.555 294.744 183.851 330.776 183.851C366.807 183.851 396.177 212.616 396.177 247.82V299.414C396.17 300.634 395.92 301.841 395.443 302.964C394.965 304.086 394.27 305.103 393.397 305.956C392.524 306.808 391.491 307.479 390.357 307.929C389.223 308.379 388.011 308.6 386.791 308.579ZM284.066 290.411H377.486V247.82C377.128 235.669 372.05 224.136 363.33 215.668C354.609 207.2 342.932 202.463 330.776 202.463C318.62 202.463 306.943 207.2 298.222 215.668C289.501 224.136 284.424 235.669 284.066 247.82V290.411Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M401.163 283.69H258.531V401.675H401.163V283.69Z",
    fill: "#455A64",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M322.19 346.112L322.223 345.778L321.926 345.621C319.572 344.377 317.601 342.514 316.226 340.234C314.852 337.957 314.123 335.349 314.118 332.689C314.261 328.799 315.906 325.116 318.707 322.413C321.511 319.709 325.255 318.197 329.151 318.197C333.047 318.197 336.791 319.709 339.595 322.413C342.396 325.115 344.041 328.798 344.184 332.687C344.164 335.363 343.412 337.982 342.01 340.26C340.606 342.542 338.603 344.395 336.22 345.618L335.918 345.774L335.95 346.112L338.501 372.37H319.639L322.19 346.112Z",
    fill: "url(#paint2_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M698.779 29.3307L698.904 29.6482H699.245H722.261V53.5573H682.749V23.5723H696.522L698.779 29.3307Z",
    fill: "url(#paint3_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M698.779 69.6004L698.903 69.9185H699.245H722.261V93.8074H682.749V63.8224H696.521L698.779 69.6004Z",
    fill: "url(#paint4_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M682.249 134.578H722.761V109.669H699.245L696.863 103.573H682.249V134.578Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M698.779 362.394L698.904 362.712H699.245H722.261V386.621H682.749V356.636H696.522L698.779 362.394Z",
    fill: "url(#paint5_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M698.779 402.664L698.903 402.982H699.245H722.261V426.871H682.749V396.886H696.521L698.779 402.664Z",
    fill: "url(#paint6_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M682.249 467.642H722.761V442.732H699.245L696.863 436.656H682.249V467.642Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M698.779 485.527L698.904 485.844H699.245H722.261V509.754H682.749V479.769H696.522L698.779 485.527Z",
    fill: "url(#paint7_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M698.779 525.797L698.903 526.115H699.245H722.261V550.004H682.749V520.019H696.521L698.779 525.797Z",
    fill: "url(#paint8_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M682.249 590.774H722.761V565.865H699.245L696.863 559.789H682.249V590.774Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M622.035 254.037C621.741 250.005 621.741 245.957 622.035 241.925",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M635.175 252.987C634.933 249.58 634.933 246.16 635.175 242.753",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M621.772 248.001L634.954 247.9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M622.055 240.351C622.402 236.323 623.023 232.324 623.912 228.381",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M635.196 241.441C635.498 238.045 636.024 234.674 636.77 231.348",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M622.781 234.335L635.801 236.354",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M624.275 226.847C625.241 222.915 626.502 219.062 628.05 215.321",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M637.073 230.036C637.895 226.721 638.954 223.469 640.242 220.307",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M625.951 221.013L638.486 225.111",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M628.655 213.867C630.253 210.153 632.115 206.557 634.226 203.108",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M640.767 219.075C642.12 215.941 643.692 212.906 645.47 209.992",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M631.239 208.397L642.947 214.453",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M635.054 201.776C636.124 200.06 637.275 198.405 638.506 196.79L642.301 192.087",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M646.177 208.861C647.08 207.406 648.057 205.998 649.104 204.642L652.313 200.605",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M638.506 196.79L649.104 204.642",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M643.29 190.856C644.663 189.382 646.116 187.969 647.529 186.516C648.256 185.809 648.922 185.062 649.689 184.497L652.01 182.479",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M653.141 199.616L656.734 195.963C657.339 195.357 657.904 194.711 658.55 194.146L660.569 192.531",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M647.529 186.516L656.734 195.963",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M653.242 181.449C654.757 180.107 656.37 178.879 658.066 177.775C659.741 176.665 661.397 175.494 663.112 174.424",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M661.558 191.663C662.824 190.533 664.173 189.501 665.595 188.575C667.028 187.646 668.421 186.556 669.854 185.749",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M658.066 177.775L665.615 188.575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M664.505 173.678L669.834 170.791C671.671 169.963 673.549 169.217 675.406 168.429",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M671.065 185.103L675.567 182.68L680.27 180.682",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M669.834 170.791L675.567 182.68",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M676.879 167.804C678.736 167.057 680.714 166.572 682.632 165.926L685.518 165.038L688.486 164.412",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M681.501 180.157C683.096 179.511 684.751 179.107 686.366 178.583L688.829 177.815L691.332 177.291",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M682.632 165.926L686.366 178.583",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M690.04 164.17C692.001 163.712 693.991 163.381 695.995 163.181C698.013 162.979 700.032 162.697 702.051 162.575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M692.644 177.028C694.301 176.614 695.989 176.33 697.69 176.18C699.386 176.019 701.082 175.757 702.777 175.656",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M695.995 163.1L697.691 176.181",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M703.605 162.454L709.661 162.374L715.716 162.858",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M704.109 175.636L709.237 175.555L714.344 175.979",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M709.661 162.374L709.237 175.555",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M717.291 162.979C719.31 163.221 721.328 163.665 723.347 164.009C724.336 164.19 725.365 164.352 726.314 164.554L729.241 165.381",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M715.676 176.08C717.371 176.281 719.047 176.665 720.722 176.948C721.55 177.089 722.398 177.23 723.245 177.412L725.688 178.098",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M723.266 164.009L720.723 176.948",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M730.674 165.825C734.56 166.939 738.364 168.322 742.059 169.963",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M726.98 178.482C730.255 179.428 733.465 180.588 736.588 181.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M736.427 167.703L731.845 180.076",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M743.472 170.69L748.861 173.455C750.617 174.444 752.273 175.615 753.968 176.705",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M737.779 182.579L742.341 184.921C743.815 185.749 745.208 186.758 746.661 187.666",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M748.861 173.456L742.341 184.921",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M755.3 177.553C756.977 178.678 758.587 179.898 760.125 181.207C761.736 182.425 763.273 183.74 764.727 185.143",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M747.771 188.393C749.18 189.337 750.528 190.369 751.808 191.481C753.186 192.504 754.494 193.616 755.724 194.812",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M760.125 181.207L751.849 191.481",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M765.857 186.253C767.27 187.686 768.784 189.039 770.117 190.553L773.972 195.236",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M756.713 195.74C757.904 196.972 759.196 198.102 760.306 199.374L763.577 203.411",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M770.117 190.553L760.307 199.374",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M774.981 196.467C777.362 199.741 779.526 203.166 781.461 206.721",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M764.424 204.339C766.422 207.108 768.243 210 769.874 212.999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M778.373 201.473L767.291 208.599",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M782.208 208.094L783.621 210.759L784.812 213.564C785.559 215.422 786.447 217.258 787.053 219.176",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M770.5 214.17L771.711 216.431L772.7 218.793C773.326 220.387 774.113 221.921 774.719 223.536",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M784.812 213.564L772.701 218.792",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M787.537 220.69C788.122 222.709 788.768 224.525 789.273 226.483L790.525 232.418",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M775.001 224.828C775.486 226.463 776.051 228.078 776.495 229.733L777.545 234.739",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M789.273 226.483L776.496 229.733",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M790.847 233.972C791.425 237.985 791.748 242.03 791.816 246.083",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M777.828 236.051C778.294 239.397 778.564 242.767 778.635 246.144",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M791.513 239.988L778.373 241.138",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M791.817 247.618C791.817 248.627 791.817 249.636 791.817 250.646L791.574 253.653C791.373 255.672 791.352 257.69 790.969 259.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M778.655 247.597C778.655 248.445 778.655 249.293 778.655 250.141L778.454 252.704C778.37 254.408 778.194 256.106 777.929 257.791",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M791.595 253.653L778.454 252.704",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M790.706 261.243C790.323 263.261 790.04 265.28 789.576 267.198L787.92 273.031",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M777.686 259.043C777.343 260.718 777.121 262.414 776.718 264.069L775.325 268.994",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M789.576 267.198L776.738 264.13",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M787.476 274.545C786.139 278.362 784.547 282.084 782.712 285.688",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M774.981 270.347C773.837 273.558 772.488 276.693 770.944 279.733",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M785.276 280.197L773.104 275.11",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M781.986 287.101L780.593 289.786C780.089 290.654 779.503 291.481 778.978 292.349L775.668 297.396",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M770.339 280.924L769.168 283.205C768.744 283.952 768.24 284.638 767.796 285.365L764.99 289.664",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M778.978 292.349L767.795 285.365",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M774.679 298.647L770.864 303.451C769.592 305.026 768.078 306.378 766.685 307.831",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M764.142 290.694L760.932 294.731C759.863 296.063 758.571 297.194 757.4 298.425",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M770.863 303.35L760.932 294.691",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M765.575 308.861C764.148 310.302 762.631 311.65 761.033 312.898C759.514 314.231 757.917 315.471 756.249 316.612",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M756.451 299.414C755.255 300.634 753.973 301.767 752.616 302.805C751.338 303.939 749.989 304.991 748.579 305.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M761.033 312.878L752.616 302.724",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M754.957 317.581C753.242 318.671 751.647 319.923 749.85 320.872L744.521 323.637",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M747.408 306.6C745.954 307.529 744.622 308.619 743.108 309.386L738.607 311.828",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M749.85 320.77L743.189 309.386",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M743.108 324.344C739.437 326.034 735.653 327.471 731.784 328.643",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M737.497 312.414C734.39 313.832 731.194 315.046 727.929 316.047",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M737.517 326.705L732.773 314.392",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M730.27 329.107C728.347 329.724 726.385 330.21 724.396 330.561C722.399 331.025 720.377 331.375 718.34 331.61",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M726.637 316.431C725.014 316.957 723.354 317.362 721.671 317.642C720.017 318.053 718.338 318.357 716.645 318.55",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M724.396 330.561L721.671 317.642",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M716.867 331.711C714.848 331.893 712.83 332.276 710.811 332.256H704.755",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M715.313 318.691C713.62 318.937 711.915 319.092 710.206 319.156H705.079",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M710.831 332.337L710.206 319.156",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M703.201 332.377C699.135 332.187 695.088 331.708 691.09 330.944",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M703.746 319.196C700.358 319.021 696.986 318.617 693.653 317.985",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M697.166 331.893L698.639 318.792",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M689.616 330.661C687.63 330.299 685.668 329.813 683.742 329.208C681.78 328.721 679.852 328.107 677.969 327.371",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M692.281 317.743C690.6 317.442 688.941 317.031 687.315 316.511C685.663 316.101 684.039 315.589 682.45 314.977",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M683.742 329.208L687.315 316.511",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M676.496 326.806C674.619 326.019 672.681 325.393 670.884 324.485L665.495 321.618",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M681.199 314.493C679.624 313.827 677.989 313.322 676.475 312.474L671.934 310.133",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M670.884 324.485L676.475 312.535",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M664.102 320.972C660.751 318.712 657.238 316.713 654.009 314.129",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M670.702 309.507C667.876 307.488 664.869 305.914 662.245 303.734",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M659.015 317.662L666.443 306.762",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M652.878 313.161C649.747 310.598 646.806 307.812 644.077 304.824",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M661.235 302.967C658.6 300.792 656.118 298.438 653.807 295.922",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M648.336 309.143L657.4 299.555",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M643.008 303.673C640.349 300.627 637.901 297.403 635.68 294.025",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M652.899 294.933C650.648 292.388 648.578 289.69 646.702 286.859",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M639.172 298.97L649.669 290.976",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M634.812 292.692C632.666 289.264 630.764 285.689 629.12 281.994",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M645.975 285.688C644.164 282.789 642.559 279.767 641.17 276.645",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M631.784 287.444L643.431 281.247",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M628.474 280.561C626.923 276.824 625.629 272.987 624.598 269.075",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M640.626 275.433C639.316 272.275 638.223 269.031 637.355 265.724",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M626.354 274.888L638.829 270.629",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M624.275 267.561C623.33 263.629 622.656 259.636 622.257 255.611",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M637.012 264.432C636.22 261.109 635.647 257.738 635.296 254.339",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M622.983 261.626L635.983 259.406",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M707.44 195.962C714.732 196.053 721.922 197.692 728.533 200.771C735.144 203.85 741.025 208.298 745.787 213.821C750.548 219.345 754.082 225.817 756.154 232.809C758.226 239.801 758.788 247.154 757.804 254.38",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M658.813 228.926C662.591 219.129 669.273 210.721 677.965 204.829C686.656 198.938 696.941 195.844 707.44 195.963",
    stroke: "#399877",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M716.1 298.001C707.111 299.646 697.846 298.867 689.258 295.744C680.67 292.621 673.068 287.268 667.235 280.234C661.401 273.2 657.546 264.739 656.066 255.722C654.586 246.704 655.534 237.455 658.813 228.926",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M757.804 254.38C756.329 265.115 751.503 275.111 744.015 282.943C736.527 290.776 726.758 296.045 716.1 298.001",
    stroke: "#399877",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M278.252 554.561H318.765V529.652H295.249L292.867 523.556H278.252V554.561Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M278.252 594.811H318.765V569.902H295.249L292.867 563.826H278.252V594.811Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M278.252 635.061H318.765V610.152H295.249L292.867 604.076H278.252V635.061Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M342.847 554.561H383.359V529.652H359.843L357.461 523.556H342.847V554.561Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M342.847 594.811H383.359V569.902H359.843L357.461 563.826H342.847V594.811Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M342.847 635.061H383.359V610.152H359.843L357.461 604.076H342.847V635.061Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M294.783 23.1735L294.907 23.4916H295.249H318.265V47.4007H278.752V17.3955H292.525L294.783 23.1735Z",
    fill: "url(#paint9_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M294.783 63.4243L294.908 63.7418H295.249H318.265V87.6509H278.752V57.6659H292.526L294.783 63.4243Z",
    fill: "url(#paint10_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M294.783 103.675L294.908 103.992H295.249H318.265V127.901H278.752V97.9161H292.526L294.783 103.675Z",
    fill: "url(#paint11_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M342.847 47.9006H383.359V22.9915H359.843L357.461 16.8954H342.847V47.9006Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M359.378 63.4243L359.502 63.7418H359.843H382.859V87.6509H343.347V57.6659H357.12L359.378 63.4243Z",
    fill: "url(#paint12_linear_2067_17274)",
    stroke: "#1C2329"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M342.847 128.401H383.359V103.492H359.843L357.461 97.4161H342.847V128.401Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2067_17274",
    x1: 208.713,
    y1: 91.4355,
    x2: 439.21,
    y2: 181.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2067_17274",
    x1: 367.909,
    y1: 109.53,
    x2: 581.04,
    y2: 193.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2067_17274",
    x1: 321.485,
    y1: 310.434,
    x2: 362.814,
    y2: 330.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2067_17274",
    x1: 692.508,
    y1: 18.9934,
    x2: 722.057,
    y2: 51.9666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2067_17274",
    x1: 692.508,
    y1: 59.2435,
    x2: 722.057,
    y2: 92.2167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2067_17274",
    x1: 692.508,
    y1: 352.057,
    x2: 722.057,
    y2: 385.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2067_17274",
    x1: 692.508,
    y1: 392.307,
    x2: 722.057,
    y2: 425.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2067_17274",
    x1: 692.508,
    y1: 475.19,
    x2: 722.057,
    y2: 508.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2067_17274",
    x1: 692.508,
    y1: 515.44,
    x2: 722.057,
    y2: 548.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2067_17274",
    x1: 288.512,
    y1: 12.8139,
    x2: 318.082,
    y2: 45.7895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2067_17274",
    x1: 288.512,
    y1: 53.087,
    x2: 318.061,
    y2: 86.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2067_17274",
    x1: 288.512,
    y1: 93.3372,
    x2: 318.061,
    y2: 126.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2067_17274",
    x1: 353.106,
    y1: 53.087,
    x2: 382.655,
    y2: 86.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72D65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#035E93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/Image 2.0b44bb84fe339df18dee71e89c0c3407.svg";
export { ForwardRef as ReactComponent };